export default import.meta.ROLLDOWN_FILE_URL_dDDWH5SEROTs7wiZgIgc1Q